import { LOGGER_LABEL_PREFIX } from "../../constants";

export const TRACK_DYNAMIC_VARIABLE = "trackDynamicVariable";
export const AFTER_PAGE_VIEW = "afterPageView";
export const LOGGER_LABEL = `${LOGGER_LABEL_PREFIX}:processContentSquareEvents`;

export const VERSION = "v1.13.0";
export const TRACKING_VARIABLE_PREFIX = "AB_DY_SS_";
